import { createRouter, createWebHistory } from 'vue-router';
import Register from '@/views/Register.vue';
import Validation from '@/views/Validation.vue';
import Login from '@/views/Login.vue';
import Entrer from '@/views/Entrer.vue';
import Rubriques from '@/views/Rubrique.vue';
import UserProfile from '@/views/UserProfile.vue';
import Friends from '@/views/Friends.vue';
import Messages from '@/views/Messages.vue';
import Notifications from '@/views/Notifications.vue';
import Conversation from '@/views/Conversation.vue';
import Moderation from '@/views/Moderation.vue';
import ComingSoon from '@/views/ComingSoon.vue';
import LegalNotice from '@/views/LegalNotice.vue';
import PrivacyPolicy from '@/views/PrivacyPolicy.vue';
import TermsOfUse from '@/views/TermsOfUse.vue';
import Post from '@/views/Post.vue';
import api from '@/api';
import ClubDesChippies from '@/views/ClubDesChippies.vue';
import CentresInteret from '@/views/CentresInteret.vue';
import UserSearchEngine from '@/views/UserSearchEngine.vue';
import GroupesEntraide from '@/views/GroupesEntraide.vue';
import GroupeEntraideDetail from '@/views/GroupeEntraideDetail.vue';

const routes = [
  { path: '/club-des-chippies', component: ClubDesChippies, meta: { checkSession: true } },
  { path: '/centres-d-interet', component: CentresInteret, meta: { checkSession: true }},
  { path: '/entrer', component: Entrer},
  { path: '/rubriques', component: Rubriques},
  { path: '/register', component: Register, meta: { requiresUnauth: true } },
  { path: '/Validation', component: Validation },
  { path: '/Friends', component: Friends, meta: { checkSession: true } },
  { path: '/Messages', component: Messages, meta: { checkSession: true }  },
  { path: '/Notifications', component: Notifications, meta: { checkSession: true } },
  // Fil de messages privés avec un membre (pas « /message… » : préfixe proxifié vers l'API en prod)
  { path: '/conversation/:userId', name: 'Conversation', component: Conversation, props: true, meta: { checkSession: true } },
  // Signalements : le rôle ADMIN / MODERATOR est vérifié par l'API
  { path: '/moderation', component: Moderation, meta: { checkSession: true } },
  // Rubriques en préparation : page « bientôt » commune, texte à compléter
  {
    path: '/a-venir',
    component: ComingSoon,
    props: { title: 'À venir', description: 'Les prochains événements et nouveautés de Wedoomotion seront bientôt annoncés ici.' },
  },
  {
    path: '/questionnaires',
    component: ComingSoon,
    props: { title: 'Questionnaires', description: 'Les questionnaires seront bientôt disponibles.' },
  },
  {
    path: '/notre-volonte',
    component: ComingSoon,
    props: { title: 'Notre volonté', description: 'La présentation de notre démarche sera bientôt en ligne.' },
  },
  // Pages légales (RGPD), accessibles connecté ou non ; liens dans AppFooter
  { path: '/mentions-legales', component: LegalNotice },
  { path: '/confidentialite', component: PrivacyPolicy },
  { path: '/cgu', component: TermsOfUse },
  {
    path: '/publication/:postId',
    name: 'Post',
    component: Post,
    props: true,
  },
  { path: '/profil/:username', name: 'UserProfile', component: UserProfile, props: true, },
  { path: '/login', component: Login, meta: { requiresUnauth: true } },
  // Add a default route that redirects to /home
  { path: '/', redirect: '/entrer' },
  { path: '/chercher-utilisateur', component: UserSearchEngine, meta: {checkSession: true} },
  { path: '/groupes-entraide', component: GroupesEntraide, meta: { checkSession: true } },
  { path: '/groupes-entraide/:geId', name: 'GroupeEntraideDetail', component: GroupeEntraideDetail, props: true, meta: { checkSession: true } },
  // URL inconnue ou mal saisie : redirection vers l'adresse de base (doit rester en dernier)
  // (query et hash vidés : vue-router les conserverait sinon lors de la redirection)
  { path: '/:pathMatch(.*)*', redirect: () => ({ path: '/', query: {}, hash: '' }) }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const checkSession = async () => {
  try {
    const response = await api.get('/session/me');

    return response.status === 200;
  } catch (error) {
    console.error('Error checking session:', error);
    return false;
  }
};

router.beforeEach(async (to, from, next) => {
  // Check if the route explicitly requires a session check
  if (to.matched.some((route) => route.meta.checkSession)) {
    const isAuthenticated = await checkSession();
    if (isAuthenticated) {
      next();
    } else {
      next('/login');
    }
  } else if (to.matched.some((route) => route.meta.requiresUnauth)) {
    // Check if the route requires the user to be unauthenticated
    const isAuthenticated = await checkSession();
    if (isAuthenticated) {
      next('/Rubriques');
    } else {
      // The user is not authenticated, proceed to the route
      next();
    }
  } else {
    // Continue to non-protected routes
    next();
  }
});

export default router;
